import script from "./DetailPageHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailPageHeader.vue?vue&type=script&setup=true&lang=ts"

import "./DetailPageHeader.vue?vue&type=style&index=0&id=ad7e69dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad7e69dc"]])

export default __exports__